define('SageDotCom/DataLayer/Events/top-nav-select',[
    "jquery",
    "SageDotCom/DataLayer/Events/eventBase",
    "SageDotCom/PolyFills/closest"
], function ($, EventBase) {

    function TopNavSelectEvent(link) {
        EventBase.call(this);
        
        var topMenuItem = link.closest('li.open');
        
        this.props = {
            "event_name": "top_nav_select",
            "event_non-int ": "0", 
            "event_category": "component", 
            "event_action": "top_nav_select",
            "event_label": this.getEventLabel(link), // title of clicked menu item
            "event_name_level_1": this.getId(link), // element id of clicked menu item
            "event_name_level_2": link.href, // url
            "event_name_level_3": topMenuItem && topMenuItem.firstElementChild ? this.cleanseString(topMenuItem.firstElementChild.text) : "", // top menu title
            "event_name_level_4": this.getSubMenuTitle(link) // sub menu title
        }
    }

    TopNavSelectEvent.prototype = Object.create(EventBase.prototype);

    TopNavSelectEvent.prototype.constructor = TopNavSelectEvent;

    TopNavSelectEvent.prototype.getEventLabel = function (link) {
        var label = '';

        // if the text inside the link has a '/' then we need to look somewhere else for the label
        // Try to get nearest label
        var labelEl = this.findTagByParentChildAndDepth($(link), 'div', 'caption', 'h2', 3);
        if (labelEl != null) {
            var itemLabel = labelEl.text();
            label = this.cleanseString(itemLabel);
        }

        // Grab the text inside the link if nothing else is found
        if (label === '') {
            // some of the links contain p tags and then a span tag to give more info within a 
            // anchor tag and in that case grab the text from the p tag only
            if ($(link).find('p').length)
                label = this.cleanseString($(link).find('p').text())
            else
                label = this.cleanseString(link.text);
        }
        
        return label;
    }

    TopNavSelectEvent.prototype.getSubMenuTitle = function (link) {

        var title = '';

        // Try to get nearest sub title
        var subMenuTitleEl = this.findTagByParentAndChild($(link), 'div', 'h3');
        if (subMenuTitleEl != null) {
            var subHeading = subMenuTitleEl.text();
            title = this.cleanseString(subHeading);
        }

        if (!title) {
            var container = $(link).closest('[class^="score-column"], [class^="score-left"], [class^="score-center"], [class^="score-right"]')[0];

            if (container) {
                title = $('h3', container).text();
            }
        }

        if (!title) {
            var heading = $(link).closest('h3').text();
            title = this.cleanseString(heading);
        }

        return title; 
    }

    TopNavSelectEvent.prototype.getMenuTitle = function (link) {
        return this.cleanseString(link.text);
    }

    // This will recurse up the tree from the original element and stop at each parentNode
    // to first determine if the tag name given is the same as the parent then it will look 
    // at the child nodes of that parent to see if it can find the child tag name and if it can
    // it will return that element else it will return null
    TopNavSelectEvent.prototype.findTagByParentAndChild = function (el, parentTag, childTag) {
        while (el.parent().length) {
            el = el.parent().first(); 
            var parentNodeName = el[0].nodeName;
            if (parentNodeName.toLowerCase() === parentTag.toLowerCase()) {
                // This pulls out the first child it finds that has the child tag
                if (el.find(childTag).length) {
                    return el.find(childTag).first();
                }
            }
        }
    }

    // This will recurse up the tree from the original element and stop at each parentNode
    // to first determine if the tag name given is the same and if the class name exists as well
    // but it will only go as high as needed so it doesn't find a false positive.   It will then
    // look for the child items and if that is found then it will return that data
    TopNavSelectEvent.prototype.findTagByParentChildAndDepth = function (el, parentTag, parentClassName, childTag, numlevels) {
        var deepCount = 0
        while (el.parent().length) {

            // break out of the loop if you reached the depth needed
            if (deepCount >= numlevels) {
                break;
            }

            el = el.parent().first();
            var parentNodeName = el[0].nodeName;
            var hasClassName = el[0].className.toLowerCase().indexOf(parentClassName) > -1;
            if (parentNodeName.toLowerCase() === parentTag.toLowerCase() && hasClassName) {
                // This pulls out the first child it finds that has the child tag
                if (el.find(childTag).length) {
                    return el.find(childTag).first();
                }
            }

            deepCount++;
        }
    }

    return TopNavSelectEvent;
});
